<template>
    <div class="cn">
        <div class="cn-content">
            <h3>{{ value }}</h3>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CircleNumber',
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
};
</script>
